import { render } from "./CatalogItem_Dialog.vue?vue&type=template&id=cd551062&scoped=true&ts=true"
import script from "./CatalogItem_Dialog.vue?vue&type=script&lang=ts"
export * from "./CatalogItem_Dialog.vue?vue&type=script&lang=ts"

import "./CatalogItem_Dialog.vue?vue&type=style&index=0&id=cd551062&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd551062"]])

export default __exports__